<template>
  <div
    class="comp-root"
  >
    <video
      ref="video"
      class="video"
      :src="videoSrc"
      controls
      autoplay
      playsinline
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      videoSrc: `${this.$backEndBaseUrl}publicityVideo/%E5%8D%97%E4%BA%AC%E5%8D%9A%E7%89%A9%E9%A6%86518%E5%AE%A3%E4%BC%A0%E8%A7%86%E9%A2%915.mp4`,
      beganPlay: false,
      showPlayBtn: false,
    }
  },
  created() {
  },
  mounted() {
  },
  destroyed() {
    clearInterval(this.intervalId)
    // qq浏览器的bug：本组件被销毁后，视频元素依然存在。需要刷新页面。
    if (window.navigator.userAgent.includes('MQQBrowser')) {
      history.go()
    }
  },
  methods: {
    onPlay() {
      this.beganPlay = true
    },
    onCanPlayThrough() {
      if (!this.beganPlay) {
        this.showPlayBtn = true
      }
    },
    onClickPlay() {
      this.showPlayBtn = false
      this.$refs.video.play()
    }
  }
}
</script>

<style lang="less" scoped>
.comp-root {
  position: absolute;
  height: 100%;
  width: 100%;
  background: #000;
  display: flex;
  justify-content: center;
  flex-direction: column;
  // .video不能通过绝对定位+transform的方式实现居中，否则在ios 15.0上会只有声音没有画面！
  .video {
    width: 100%;
  }
}
</style>
